import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getRequisitions = ({ churchId, queries }) => {
  const queryBuilder = new QueryBuilder();

  if (queries.filter) {
    queryBuilder.filter(queries.filter);
  }

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.sort) {
    queryBuilder.sort(queries.sort);
  }

  const queryString = queryBuilder.build();

  return axios.get(`/churches/${churchId}/requisitions${queryString}`);
};

export const useRequisitions = ({ churchId, queries = {}, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["requisitions", churchId, JSON.stringify(queries)],
    queryFn: () => getRequisitions({ churchId, queries })
  });
};
